import { Configuration, LogLevel } from '@azure/msal-browser';
import { VITE_MSAL_CLIENT_ID, VITE_MSAL_TENANT_ID } from '@src/main/env';

export const msalConfig: Configuration = {
  auth: {
    clientId: VITE_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/188b450b-7545-493f-9096-854ed4977730`,
    redirectUri: `${window.location.origin}/login`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {},
      logLevel: LogLevel.Info,
    },
  },
};
